export const MEDICINE_MENUS = ['Medicine Form List', 'Medicine Reports']
